import { Checkbox, Chip, FormControl, MenuItem } from "@mui/material";
import { styled } from "@mui/styles";
import ClearIcon from "@mui/icons-material/Clear";

export const FormContainer = styled(FormControl)(({ isValue, multiSelWidth }) => ({
    "& label": {
        fontSize: 14,
        color: "#2c2f44",
        fontFamily: 'Roboto, sans-serif',
        textTransform: "inherit",
        backgroundColor: "white !important",
    },
    "& label.MuiInputLabel-shrink": {
        fontSize: "1rem",
    },
    "& label.Mui-focused": {
        color: "#638dff",
    },
    "& div": {
        padding: "4px 5px 6px 5px",
        paddingBottom: "4px",
    },
    "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderColor: "#638dff !important",
    },
    "& .MuiSelect-icon": {
        color: "#638dff !important",
    },
    "& .MuiOutlinedInput-root": {
        "& .MuiSelect-select": {
            ...(isValue ? { maxWidth: `${multiSelWidth}px` } : { width: "100%" }),
        },
        "& fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#c4d8ff",
        },
        "&:hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#92afff",
        },
        "&.Mui-disabled": {
            backgroundColor: "#f4f7fb !important",
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4d8ff",
            },
        },
        "&.Mui-error": {
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#f2a29d !important",
            },
        },
        "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#638dff",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            color: "#44485a",
            "WebkitTextFillColor": "#44485a",
        },
        "& .MuiFormHelperText-root": {
            color: "#e5453b !important",
        },

        fontSize: 14,
        borderRadius: 6,
        fontFamily: 'Roboto, sans-serif',
    },
}));

export const StyledMenuItem = styled(MenuItem)({
    "&.MuiButtonBase-root.MuiMenuItem-root.Mui-selected": {
        backgroundColor: "#eff4ff !important",
    },
    borderBottom: "1px solid rgba(196, 216, 255, 0.5)",
    paddingTop: "5px",
    paddingBottom: "5px",
});

export const StyledCheckBoxItem = styled(Checkbox)(({ checked }) => ({
    color: "#638dff	",
    "& .MuiSvgIcon-root": {
        fontSize: "1.5rem",
        border: "none !important",
    },

    "&.Mui-checked .MuiSvgIcon-root": {
        // backgroundColor: "rgba(196, 216, 255, 0.5) !important",
        border: "none !important",
    },
}));

export const ChipDiv = styled("div")(() => ({
    display: "flex",
    flexWrap: "wrap",
}));

export const ChipChild = styled(Chip)(() => ({
    margin: 2,
    border: "solid 1px #c4d8ff",
    backgroundColor: "#f6f8fc",
    fontSize: "14px",
    fontWeight: "500",
    color: "#4f5b7d",
    "&	.MuiChip-deleteIcon": {
        color: "#4f5b7d",
        fontSize: "medium",
    },
}));


export const PositionCloseIcon = styled(ClearIcon)(() => ({
    position: "absolute",
    // left: "84%",
    // top: "10px",
    // top: "calc(50% - 12px)",
    top: " 35%  ",
    left: "85% ",
    transform: " translate(-50%, -50%) ",
    color: "rgba(0, 0, 0, 0.54)",
}));


export const FormContainer2 = styled(FormControl)(({ isValue }) => ({
    "& label": {
        fontSize: 14,
        color: "#2c2f44",
        fontFamily: 'Roboto, sans-serif',
        textTransform: "inherit",
    },
    "& label.MuiInputLabel-shrink": {
        fontSize: "1rem",
    },
    "& label.Mui-focused": {
        color: "#638dff",
    },
    "& div": {
        padding: "4px 5px 6px 5px",
        paddingBottom: "4px",
    },
    "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderColor: "#638dff !important",
    },
    "& .MuiSelect-icon": {
        color: "#638dff !important",
    },
    "& .MuiOutlinedInput-root": {
        "& .MuiSelect-select": {
            ...(isValue ? { width: "min-content" } : { width: "100%" }),
        },
        "& fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#c4d8ff",
        },
        "&:hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#92afff",
        },
        "&.Mui-disabled": {
            backgroundColor: "#f4f7fb !important",
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4d8ff",
            },
        },
        "&.Mui-error": {
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#f2a29d !important",
            },
        },
        "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#638dff",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            color: "#44485a",
            "WebkitTextFillColor": "#44485a",
        },
        "& .MuiFormHelperText-root": {
            color: "#e5453b !important",
        },
        fontSize: 14,
        borderRadius: 6,
        fontFamily: 'Roboto, sans-serif',
    },
}));


export const ChipChild2 = styled(Chip)(() => ({
    margin: 2,
}));


export const PositionCloseIconMulti = styled(ClearIcon)(() => ({
    position: "absolute",
    // left: "84%",
    // top: "10px",
    // top: "calc(50% - 3px)",
    color: "rgba(0, 0, 0, 0.54)",

    //aditya
    top: " 33%  ",
    left: "87% ",
    transform: " translate(-50%, -50%) ",
}));
